<template>
  <div class="wraper">
    <div class="logo">
      <!-- <img v-if="store.getters.sideBarOpened"  src="@/assets/images/logo-white.png" alt="" /> -->
      <img :class="[sideBarOpened?'':'collapse']" v-if="orgUrl" :src="orgUrl" alt="" onerror="this.src='/images/logo-short.png'">
      <img :class="[sideBarOpened?'':'collapse']" v-else src="@/assets/images/logo-short.png" alt="">
      <div v-if="sideBarOpened" class="org-short-name">{{orgName}}</div>
    </div>
    <menu-bar></menu-bar>
  </div>
</template>
<script lang="ts">
import MenuBar from './MenuBar.vue'
import store from '@/store'
import { defineComponent,computed } from 'vue'
export default defineComponent({
  components: {
    'menu-bar': MenuBar,
  },
  setup(){
    const logoHeight = 40
    const sideBarOpened=computed(()=>{
      return store.getters.sideBarOpened
    })
    const orgName=computed(()=>{
      return store.getters.userInfo.orgShortName?store.getters.userInfo.orgShortName:""
    })
    const orgUrl=computed(()=>{
      return store.getters.userInfo.logoUrl?"https://allfiles.landiyun.com/"+store.getters.userInfo.logoUrl+'?x-oss-process=image/resize,w_200,m_lfit':''
    })
    return {
      store,logoHeight,orgName,orgUrl,sideBarOpened
    }
  }
})

</script>
<style lang="scss" scoped>
.wraper { display:flex; flex-direction:column; height:100vh; min-height:0; }
.wraper :deep(.siderbar-menu) { flex:1; min-height:0; height:auto; }
.wraper .logo {
 display:flex; align-items:center; justify-content:center; gap:2px;
 padding:8px 4px; box-sizing:border-box; color:white; min-height:70px; flex:0 0 auto;
 img { width:26px; height:26px; object-fit:contain; flex:0 0 26px; margin:0; }
 .org-short-name { flex:1; min-width:0; font-size:12px; line-height:1.4; white-space:normal; overflow-wrap:anywhere; word-break:normal; text-align:left; }
 .collapse { width:26px; height:26px; }
}
</style>
